import React, { Component } from "react";
import { Col, Row, } from "react-bootstrap";
import ReactTable from "react-table";
import debounce from "lodash/debounce";
import moment from "moment";
import DayOffRequestsService from "../../../services/DayOffRequestsService";
import DayOffResponseService from "../../../services/DayOffResponseService";
import HandleError from "../../../services/HandleError";
import DayOffDetailsModal from "../../modals/DayOffDetailsModal";
import DayOffConfirmationModal from "../../modals/DayOffConfirmationModal";

class DaysOffRequestsPage extends Component {
	state = {
		showConfirmationModal: false,
		showDetailsModal: false,
		showReplyMessage: false,
		isLoadingTable: true,
		actionLoading: false,
		message: "",
		formData: {},
		data: [],
		pages: 1,
	}

	onChange = (e) => { this.setState({ formData: { ...this.state.formData, [e.target.name]: e.target.value } }); }

	getDayOffRequests = (state) => {
		const { pageSize, sorted, filtered, page } = state;
		const data = JSON.stringify({ pageSize, sorted, filtered, page });
		this.setState({ isLoadingTable: true });
		this.dayOffRequestService.index(page + 1, `data=${data}`).then((res) => {
			this.setState({ isLoadingTable: false, data: res.data.data, pages: res.data.last_page, pageState: state });
		}).catch((err) => {
			this.setState({ isLoadingTable: false });
			HandleError(err, this);
		});
	}

	handleRequestDetailsModal = (dayoff) => {
		if (dayoff) {
			this.setState({ showDetailsModal: true, selectedDayOff: dayoff });
		}
	}

	handleConfirmationModal = (dayoff, response_id, showReplyMessage, message) => {
		if (dayoff && response_id) {
			this.setState({
				showConfirmationModal: true,
				formData: { response_id },
				showReplyMessage: showReplyMessage || false,
				dayoff,
				response_id,
				message,
			});
		}
	}

	handleAcceptOrDecline = () => {
		if (this.state.dayoff && this.state.response_id) {
			this.setState({ actionLoading: true });
			this.dayOffResponseService.update(this.state.dayoff.id, this.state.formData).then((res) => {
				this.setState({ actionLoading: false, showConfirmationModal: false });
			}).catch((err) => {
				this.setState({ actionLoading: false });
				HandleError(err, this);
			}).then(() => {
				this.getDayOffRequests(this.state.pageState);
			});
		}
	}

	handleClose = () => { this.setState({ showDetailsModal: false }); }

	handleCloseConfirmation = () => { this.setState({ showConfirmationModal: false }); }

	dayOffRequestService = new DayOffRequestsService(this)
	dayOffResponseService = new DayOffResponseService(this)

	render() {
		const { data, isLoadingTable, pages, showDetailsModal, selectedDayOff, actionLoading, showConfirmationModal, formData, showReplyMessage, message } = this.state;
		return (
			<div className="crud-page days-off-page">
				<div className="container-fluid">
					<section className="actions">
						<Row>
							<Col md={6} sm={6} xs={12}>
								<h2 className="page-title">Day Off Requests</h2>
							</Col>
						</Row>
					</section>
					<div className="card card-top-border connection-card fadeInLoadUp">
						<ReactTable
							columns={[
								{
									Header: "Title",
									accessor: "name",
									Cell: row => <div className="text-center"><button className="btn-name" onClick={() => this.handleRequestDetailsModal(row.original)}>{row.value}</button></div>,
									minWidth: 150
								}, {
									Header: "Description",
									accessor: "description",
									Cell: row => <div className="text-center">{row.value}</div>,
									minWidth: 150
								},
								{
									Header: "User",
									accessor: "full_name",
									Cell: row => <div className="text-center">{row.value}</div>,
									minWidth: 130
								},
								{
									Header: "Start",
									accessor: "start",
									Cell: row => <div className="text-center">{moment(row.value).format("DD-MM-YYYY HH:mm")}</div>,
									minWidth: 130
								},
								{
									Header: "End",
									accessor: "end",
									Cell: row => <div className="text-center">{moment(row.value).format("DD-MM-YYYY HH:mm")}</div>,
									minWidth: 130
								}, {
									Header: "Created at",
									accessor: "created_at",
									Cell: row => <div className="text-center">{moment(row.value).format("DD-MM-YYYY HH:mm")}</div>,
									minWidth: 130
								},
								{
									Header: "Status",
									accessor: "status",
									filterable: false,
									sortable: false,
									Cell(row) {
										switch (row.value) {
										case "Approved":
											return <div className="text-center"><span className="status status-done">Approved</span></div>;
										case "Refused":
											return <div className="text-center"><span className="status status-refused">Refused</span></div>;
										case "Pending":
											return <div className="text-center"><span className="status status-to-do">Pending</span></div>;
										default:
											return <div className="text-center"><span className="status status-default">{row.value}</span></div>;
										}
									}
								}, {
									Header: "Actions",
									accessor: "id",
									filterable: false,
									sortable: false,
									Cell: row => {
										const userName = row.original.full_name || "";
										const myResponse = row.original.responded || null;
										const status = row.original.status_id || null;
										let showActions = true;
										if (status == 2 || status == 3 || myResponse === true) {  // eslint-disable-line
											showActions = false;
										}
										return (
											<div className="text-center">
												{showActions &&
													<React.Fragment>
														<button title="Approve" disabled={actionLoading} className="btn-action material-icons btn-accept" onClick={() => this.handleConfirmationModal(row.original, 2, false, `You are approving ${userName}'s day off request !`)}>check</button>
														<button title="Refuse" disabled={actionLoading} className="btn-action material-icons btn-delete" onClick={() => this.handleConfirmationModal(row.original, 3, true, `You are refusing ${userName}'s day off request !`)}>close</button>
													</React.Fragment>
												}
											</div>
										);
									},
									minWidth: 130
								}
							]}
							manual
							data={data}
							pages={pages}
							loading={isLoadingTable}
							onFetchData={debounce(this.getDayOffRequests, 400)}
							filterable
							defaultSorted={[{ id: "created_at", desc: true }]}
							defaultPageSize={20}
							className="-highlight"
						/>
					</div>
				</div>

				<DayOffDetailsModal
					showDetailsModal={showDetailsModal}
					handleClose={this.handleClose}
					selectedDayOff={selectedDayOff}
				/>

				<DayOffConfirmationModal
					isLoading={actionLoading}
					showConfirmationModal={showConfirmationModal}
					showReplyMessage={showReplyMessage}
					formData={formData}
					message={message}
					onChange={this.onChange}
					handleCloseConfirmation={this.handleCloseConfirmation}
					handleAcceptOrDecline={this.handleAcceptOrDecline}
				/>

			</div>
		);
	}
}

export default DaysOffRequestsPage;





// WEBPACK FOOTER //
// ./src/components/pages/days-off/DayOffRequestsPage.js